export default __webpack_public_path__ + "static/media/arabica-aromatic.e5b9c65c.jpg";